const baseUrl = process.env.NEXT_PUBLIC_API_URL || "";

export { baseUrl };
